import { Controller } from '@hotwired/stimulus';
import { enter, leave } from 'el-transition';

// Connects to data-controller="header"
export default class extends Controller {
  static targets = ['mobileMenu', 'openButton', 'closeButton'];

  toggleMobileMenu(e) {
    e.preventDefault()

    if (this.mobileMenuTarget.classList.contains('hidden')) {
      enter(this.mobileMenuTarget)
      this.openButtonTarget.classList.add('hidden')
      this.openButtonTarget.classList.remove('block')
      this.closeButtonTarget.classList.remove('hidden')
      this.closeButtonTarget.classList.add('block')
      document.body.style.overflow = 'hidden'
    } else {
      leave(this.mobileMenuTarget)
      this.openButtonTarget.classList.remove('hidden')
      this.openButtonTarget.classList.add('block')
      this.closeButtonTarget.classList.add('hidden')
      this.closeButtonTarget.classList.remove('block')
      document.body.style.overflow = ''
    }
  }
}
